import { isArray } from 'util';
import { sortByString, mapCollection } from '../../utils/collection.utils';
import { Brand } from '../brand';

export class BrandBuilder {

  static fromJson(json): Brand {
    return (json) ? new Brand(
      json.hash,
      json.name,
    ) : null;
  }

  static fromJsonList(list): Brand[] {
    return (isArray(list)) ? sortByString('name', mapCollection(BrandBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/brand.builder.ts